import { ACTION_TYPES } from '../../constants';
import { buildBaseEvent } from '../../bigQuery/builders';

const IMPRESSION_ACTION_PAYLOAD = {
    action: {
        type: ACTION_TYPES.IMPRESSION,
    },
    group: 'notification_impressions',
};

/**
 * Builds an impression event constructor.
 *
 * @param {string} type - The big query event type
 * @returns {Function}
 */
export const buildImpressionEvents = (type) => buildBaseEvent(type, IMPRESSION_ACTION_PAYLOAD);
